import i18n, { NAMESPACE } from '@app/i18n';
import { formatNumber } from '@app/i18n/formatters/number';
import { toaster } from '@chakra-primitives/toaster';

export interface CaseExposureRebuildComplete {
  rebuildId?: string;
  operation?: string;
  count?: number;
}

export const showCaseExposureRebuildCompleteToast = async (
  data: CaseExposureRebuildComplete,
): Promise<void> => {
  const operation = data?.operation;
  if (!operation) return;

  await i18n.loadNamespaces([NAMESPACE.EXPOSURES]);

  const titleKey = `${NAMESPACE.EXPOSURES}:rebuildComplete.${operation}.title`;
  if (!i18n.exists(titleKey)) return;

  const count = data?.count ?? 0;

  toaster.create({
    type: 'success',
    title: i18n.t(titleKey),
    description: i18n.t(
      `${NAMESPACE.EXPOSURES}:rebuildComplete.${operation}.summary`,
      {
        count,
        formattedCount: formatNumber(count),
      },
    ),
  });
};

export interface CaseExposureRebuildFailed {
  rebuildId?: string;
  operation?: string;
}

// Unlike completion, a failure must never go silent for an operation without copy.
export const showCaseExposureRebuildFailedToast = async (
  data: CaseExposureRebuildFailed,
): Promise<void> => {
  await i18n.loadNamespaces([NAMESPACE.EXPOSURES]);

  const operationKey = `${NAMESPACE.EXPOSURES}:rebuildFailed.${data?.operation}`;
  const copyKey = i18n.exists(`${operationKey}.title`)
    ? operationKey
    : `${NAMESPACE.EXPOSURES}:rebuildFailed.default`;

  toaster.create({
    type: 'error',
    title: i18n.t(`${copyKey}.title`),
    description: i18n.t(`${copyKey}.description`),
  });
};
